import createMedia from '~utils/createMedia';

export const BREAKPOINTS = {
  sm: 480,
  md: 768,
  lg: 990,
  xl: 1200,
};

export const media = createMedia(BREAKPOINTS);
